// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2H5R7","fileBtn":"File_fileBtn__ffnsm","closeBtn":"File_closeBtn__1Jb7_","fileSelected":"File_fileSelected__1JX2O","disabled":"File_disabled__7hyV9"};